import axios from 'axios'
import config from '../../config/index.js'
import router from '../router'

let dato = config.datoDev
if (process.env.NODE_ENV === 'prod') {
  dato = config.datoProd
}

export async function request ({ query, variables, preview }) {
  const endpoint = preview
    ? `https://graphql.datocms.com/preview`
    : `https://graphql.datocms.com/`

  const { data } = await axios.post(
    endpoint,
    {
      query,
      variables
    },
    {
      headers: {
        Authorization:
          `Bearer ` + dato
      }
    }
  )

  if (data.errors) {
    router.push({name: 'errorcontent', params: { error: data.errors[0].message }})
  }

  return data.data
}



// WEBPACK FOOTER //
// ./src/plugins/datocms.js